"use client";
import { Image } from "@components/core/Image";
import { IphoneMockup } from "@components/core/IphoneMockup";
import Pause20 from "@ui/icons/20x20/pause-20.svg";
import Play20 from "@ui/icons/20x20/play-20.svg";
import { cn } from "@ui/lib/utils";
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";
import { useState } from "react";

export const Preview = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const play = () => {
    if (isPlaying) return;

    const howl = new Howl({
      src: ["https://eleven-public-cdn.elevenlabs.io/audio/reader-app/hello-from-elevenlabs.mp3"],
      preload: true,
      onend: () => setIsPlaying(false),
      onplay: () => setIsPlaying(true),
    });

    howl.play();

    setIsPlaying(true);
    setTimeout(() => {
      setIsPlaying(false);
    }, 1200);
  };

  return (
    <div className='container flex justify-center'>
      <IphoneMockup>
        <div className='relative'>
          <AnimatePresence>
            {isPlaying ? (
              <>
                <div className='absolute left-[3%] top-[11.5%] h-[4.3%] w-[54.2%]'>
                  <m.div
                    animate={{
                      opacity: 1,
                    }}
                    className={cn("absolute left-0 top-[5%] h-[90%] w-full rounded-[5px] bg-[#e3ffdd]")}
                    exit={{
                      opacity: 0,
                    }}
                    initial={{
                      opacity: 0,
                    }}
                  />
                  <m.div
                    animate={{
                      scale: [0.8, 1, 1, 0.8],
                      opacity: [0, 1, 1, 0],
                    }}
                    className='absolute left-[2%] top-[15%] h-[70%] w-[24%] rounded-[5px] bg-[#73f273]'
                    transition={{ delay: 0.2, duration: 0.4 }}
                  />
                  <m.div
                    animate={{
                      scale: [0.8, 1, 1, 0.8],
                      opacity: [0, 1, 1, 0],
                    }}
                    className='absolute left-[23%] top-[15%] h-[70%] w-[25%] rounded-[5px] bg-[#73f273]'
                    transition={{ delay: 0.4, duration: 0.4 }}
                  />
                  <m.div
                    animate={{
                      scale: [0.8, 1, 1, 0.8],
                      opacity: [0, 1, 1, 0],
                    }}
                    className='absolute left-[44.5%] top-[15%] h-[70%] w-[52%] rounded-[5px] bg-[#73f273]'
                    transition={{ delay: 0.6, duration: 0.8 }}
                  />
                </div>
              </>
            ) : null}
          </AnimatePresence>
          <Image
            alt='ElevenLabs Reader App'
            className='pointer-events-none relative max-w-full'
            height={661}
            loading='eager'
            src='https://storage.googleapis.com/eleven-public-cdn/images/marketing/reader-app-hero.png'
            width={326}
          />
        </div>
        <button
          className='effect-focus absolute bottom-[8.1%] left-1/2 h-[7.3%] w-[15.5%] -translate-x-1/2 rounded-full'
          onClick={play}
        >
          <AnimatePresence>
            {isPlaying ? (
              <m.div
                animate={{ opacity: 1, scale: 1 }}
                className='absolute left-0 top-0 flex h-full w-full items-center justify-center'
                exit={{ opacity: 0, scale: 0.5 }}
                initial={{ opacity: 0, scale: 0.5 }}
                key='pause'
              >
                <Pause20 className='' />
              </m.div>
            ) : (
              <m.div
                animate={{ opacity: 1, scale: 1 }}
                className='absolute left-0 top-0 flex h-full w-full items-center justify-center'
                exit={{ opacity: 0, scale: 0.5 }}
                initial={{ opacity: 0, scale: 0.5 }}
                key='play'
              >
                <div className='border-gray-50 absolute bottom-0 left-0 right-0 top-0 animate-[ping_2s_ease-in-out_infinite] rounded-full border' />
                <Play20 className='translate-x-[0px]' />
              </m.div>
            )}
          </AnimatePresence>
        </button>
      </IphoneMockup>
    </div>
  );
};
